import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState } from "react";
import styled from "styled-components";
import Colors from "../../../styles/Colors";
import { H3 } from "../../../styles/Fonts";
import { getSlicedAddress } from "../../../utils/api/common";
import Button from "../../../components/Button";
import { useWeb3React } from "@web3-react/core";
import SetReferralCodeModal from "./SetReferralCodeModal";
import useReferralCode from "../../../hooks/useReferralCode";

const AccountInfo: React.FC = () => {
  const { account } = useWeb3React();
  const { referrerCode, updateReferralCode } = useReferralCode();

  const [referralModalIsShow, setReferralModalIsShow] =
    useState<boolean>(false);
  const [isSetting, setIsSetting] = useState<boolean>(false);

  return (
    <Fragment>
      <AccountInfoContainer>
        <LeftContainer>
          <UserIcon icon={faUserCircle} />
          <AccountAddress>
            {account && getSlicedAddress(account)}
          </AccountAddress>
        </LeftContainer>
        <Row>
          <Tag>Tier 0</Tag>
          {!referrerCode ? (
            <div>
              <Button
                btnText="Set Referral Code"
                onClick={() => setReferralModalIsShow(true)}
                disabled={isSetting}
                isLoading={isSetting}
                btnType={"primary"}
              />
            </div>
          ) : (
            <Tag>{`Referral Code Entered: ${referrerCode}`}</Tag>
          )}
        </Row>
      </AccountInfoContainer>
      <SetReferralCodeModal
        isShowModal={referralModalIsShow}
        setShowModal={setReferralModalIsShow}
        setIsSetting={setIsSetting}
        updateReferralCode={updateReferralCode}
      />
    </Fragment>
  );
};

export default AccountInfo;

const AccountInfoContainer = styled.div`
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

const UserIcon = styled(FontAwesomeIcon)`
  color: ${Colors.gray3};
  font-size: 32px;
  margin-right: 12px;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const AccountAddress = styled(H3)`
  font-size: 18px;
  line-height: 22px;
  color: ${Colors.ivory};
  margin-right: 16px;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

const Tag = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${Colors.gray3};
  border-radius: 8px;
  padding: 4px 12px;
  background-color: ${Colors.backgroundGray4};
  border: 0.5px solid ${Colors.gray5};
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
    padding: 0px 8px;
  }
`;

const Row = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 576px) {
    gap: 8px;
    flex-direction: column;
    align-items: flex-start;
  }
`;
